"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chargebeeSubscriptionToUserSubscription = exports.chargebeeSubscriptionToCancellationReason = exports.chargebeeSubscriptionStatusToUserSubscriptionStatus = exports.chargebeeTimeToDate = exports.dateToChargebeeTime = void 0;
const types_1 = require("@fluent-forever/types");
const time_utils_1 = require("../time_utils");
const dateToChargebeeTime = (date) => Math.floor(date.getTime() / 1000);
exports.dateToChargebeeTime = dateToChargebeeTime;
const chargebeeTimeToDate = (chargebeeTime) => new Date(chargebeeTime * 1000);
exports.chargebeeTimeToDate = chargebeeTimeToDate;
const chargebeeSubscriptionStatusToUserSubscriptionStatus = (status) => {
    switch (status) {
        case "active":
            return "auto_renewing";
        case "future":
        case "in_trial":
            return "future";
        case "paused":
            return "paused";
        case "cancelled":
        case "non_renewing":
            return "cancelled";
        default:
            throw new Error("We don't know how to map the chargebee status " + status);
    }
};
exports.chargebeeSubscriptionStatusToUserSubscriptionStatus = chargebeeSubscriptionStatusToUserSubscriptionStatus;
const chargebeeSubscriptionToCancellationReason = (sub) => {
    if (sub.status === "cancelled" || sub.status === "non_renewing") {
        if (sub.cancel_reason &&
            (sub.cancel_reason === "currency_incompatible_with_gateway" ||
                sub.cancel_reason === "no_card" ||
                sub.cancel_reason === "not_paid" ||
                sub.cancel_reason === "tax_calculation_failed")) {
            return "billing_issue";
        }
        if (sub.cancelled_at &&
            sub.current_term_end &&
            sub.cancelled_at <= sub.current_term_end) {
            return "user_cancelled";
        }
        return "other";
    }
    return undefined;
};
exports.chargebeeSubscriptionToCancellationReason = chargebeeSubscriptionToCancellationReason;
const chargebeeSubscriptionToUserSubscription = ({ sub, nextBillingAmount, isAmex, }) => {
    if (sub.meta_data && !types_1.isUserSubscriptionMetadata(sub.meta_data)) {
        throw `Invalid metadata found on chargebee subscription [${sub.id}]`;
    }
    return {
        cancellationReason: exports.chargebeeSubscriptionToCancellationReason(sub),
        cancelledAt: sub.cancelled_at
            ? exports.chargebeeTimeToDate(sub.cancelled_at).toISOString()
            : undefined,
        expiresAt: sub.current_term_end
            ? exports.chargebeeTimeToDate(sub.current_term_end).toISOString()
            : undefined,
        id: sub.id,
        isAmex,
        metadata: sub.meta_data,
        nextBillingAmount,
        nextBillingAt: sub.next_billing_at
            ? time_utils_1.secondsToDate(sub.next_billing_at).toISOString()
            : undefined,
        overdueAmount: sub.total_dues,
        planId: sub.plan_id,
        startedAt: sub.started_at
            ? time_utils_1.secondsToDate(sub.started_at).toISOString()
            : undefined,
        status: exports.chargebeeSubscriptionStatusToUserSubscriptionStatus(sub.status),
        userId: sub.customer_id,
    };
};
exports.chargebeeSubscriptionToUserSubscription = chargebeeSubscriptionToUserSubscription;
//# sourceMappingURL=chargebee_adapters.js.map